module.exports = __webpack_public_path__ + "components/layout/images/sina.png?3937dc3b";


//////////////////
// WEBPACK FOOTER
// ./components/layout/images/sina.png
// module id = 241
// module chunks = 0